import React from "react"

import { RJSFForm } from "shared/ui/rjsf-form/RJSFForm"

import { getProductType } from "entities/products/lib/getProductType"

import { useProductConfiguratorConfigurationContext } from "../model/ProductConfiguratorConfigurationContext"
import { useProductConfiguratorStatusContext } from "../model/ProductConfiguratorStatusContext"
import { useProductConfiguratorConfigurationViewModel } from "../model/useProductConfiguratorConfigurationViewModel"
import { ProductConfiguratorStatus } from "./ProductConfiguratorStatus"
import { ProductConfiguratorAttributeInformation } from "./attribute-information/ProductConfiguratorAttributeInformation"

export const ProductConfiguratorConfigurationForm = React.memo(() => {
  const {
    isConfigurable,
    isConfigurationServiceAvailable,
    isConfigurationModelFaulty,
    isConfigurationWip
  } = useProductConfiguratorStatusContext()
  const configurationViewModel = useProductConfiguratorConfigurationViewModel()
  const { isLoading, variantKey } = useProductConfiguratorConfigurationContext()

  if (
    !isLoading &&
    (isConfigurable === false || !isConfigurationServiceAvailable)
  ) {
    return (
      <ProductConfiguratorStatus
        isConfigurable={isConfigurable}
        isConfigurationServiceAvailable={isConfigurationServiceAvailable}
        isConfigurationModelFaulty={isConfigurationModelFaulty}
        isConfigurationWip={isConfigurationWip}
        productType={getProductType(variantKey ?? "")}
      />
    )
  }

  return (
    <div className="product-configuration-step__main">
      <div className="product-configuration-step__form">
        <ProductConfiguratorStatus
          isConfigurable={isConfigurable}
          isConfigurationServiceAvailable={isConfigurationServiceAvailable}
          isConfigurationModelFaulty={isConfigurationModelFaulty}
          isConfigurationWip={false}
          productType={getProductType(variantKey ?? "")}
        />

        <RJSFForm
          {...configurationViewModel}
          schema={configurationViewModel.schema || null}
          className="product-configurator-form"
          submitOnChange
          hideSubmitButton
          FieldInformationRenderer={ProductConfiguratorAttributeInformation}
        />
      </div>
    </div>
  )
})
